<div [matMenuTriggerFor]="dropdownContent" (click)="onClicked($event)">
    <ng-content></ng-content>
</div>

<mat-menu #dropdownContent="matMenu">
    <div *ngIf="!this._euiDisabled" class="eui-dropdown-content-wrapper" [style.min-width]="width">
        <ng-content select="eui-dropdown-content"></ng-content>
    </div>
</mat-menu>
